import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Location, LocationsQueryResponse, MetadataQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const LOCATION_URL = `${API_URL}/location`
const METADATA_URL = `${API_URL}/metadata`

const getLocations = (query: string): Promise<LocationsQueryResponse> => {
  return axios.get(`${LOCATION_URL}?${query}`)
}

const getLocationById = (id: ID): Promise<Location | undefined> => {
  return axios.get(`${LOCATION_URL}/${id}`)
}

const createLocation = (location: Location): Promise<Location | undefined> => {
  return axios.post(LOCATION_URL, location)
}

const updateLocation = (location: Location): Promise<Location | undefined> => {
  return axios.patch(`${LOCATION_URL}`, location)
}

const deleteLocation = (locationId: ID): Promise<void> => {
  return axios.delete(`${LOCATION_URL}/${locationId}`)
}

const deleteSelectedLocations = async (locationIds: Array<ID>): Promise<void> => {
  const requests = locationIds.map((id) => axios.delete(`${LOCATION_URL}/${id}`))
  await axios.all(requests)
}

const getCurrentLocation = async (): Promise<any> => {
  const response = await fetch(`${process.env.REACT_APP_LOCATION_URL}`)
  const data = await response.json()
  return data
}
const getMetadata = (query: string): Promise<MetadataQueryResponse> => {
  return axios.get(`${METADATA_URL}/${query}`)
}
export {
  getLocations,
  deleteLocation,
  deleteSelectedLocations,
  getLocationById,
  createLocation,
  updateLocation,
  getCurrentLocation,
  getMetadata,
}
